import { render, staticRenderFns } from "./Framer.vue?vue&type=template&id=99f9cfda&scoped=true&"
import script from "./Framer.vue?vue&type=script&lang=js&"
export * from "./Framer.vue?vue&type=script&lang=js&"
import style0 from "./Framer.vue?vue&type=style&index=0&id=99f9cfda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9cfda",
  null
  
)

export default component.exports